import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ProductionUnit } from '@shared/size2mix-shell';
import type { ProductionData } from './types';

const KEY = ['ref-network-production'];

export function useProduction() {
    return useQuery({ queryKey: KEY, queryFn: async () => (await (await fetch('/api/ref-network-production')).json()) as ProductionData });
}

export function useUpdateUnit() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ name, patch }: { name: string; patch: Partial<ProductionUnit> }) =>
            (await (
                await fetch(`/api/ref-network-production/units/${encodeURIComponent(name)}`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(patch),
                })
            ).json()) as ProductionData,
        onSuccess: (data) => qc.setQueryData(KEY, data),
    });
}
